import { useState, useEffect, useRef } from "react";
import gsap from "gsap";

export default function OrthodonticPhases() {
  const [activePhase, setActivePhase] = useState(1);
  const underlineRef = useRef(null);
  const btnRefs = [useRef(null), useRef(null)];

  useEffect(() => {
    if (underlineRef.current && btnRefs[activePhase - 1].current) {
      const { offsetLeft, offsetWidth } = btnRefs[activePhase - 1].current;
      gsap.to(underlineRef.current, {
        left: offsetLeft + "px", // Move it to the correct button position
        width: offsetWidth + "px", // Set width dynamically
        duration: 0.3,
        ease: "power2.out",
      });
    }
  }, [activePhase]);

  return (
    <div className="w-full lg:w-4/5 mx-auto p-6">
      {/* Toggle Switch */}
      <div className="relative flex justify-center border-b border-gray-300">
        {["Фаза 1: 7-11 г.", "Фаза 2: 11-13 г."].map((phase, index) => (
          <button
            key={index}
            ref={btnRefs[index]}
            onClick={() => setActivePhase(index + 1)}
            className="relative px-6 py-2 text-lg font-semibold text-gray-700 transition-colors duration-300"
          >
            {phase}
          </button>
        ))}
        {/* Animated Underline */}
        <div
          ref={underlineRef}
          className="absolute bottom-[-2px] left-0 h-[3px] bg-brand w-0 rounded-full"
        />
      </div>

      {/* Content Section */}
      <div className="bg-white shadow-lg rounded-2xl p-6 mt-4">
        {activePhase === 1 ? (
          <div className="flex flex-col items-start text-start">
            <h2 className="text-xl font-bold text-heading">
              Фаза 1: Ранно ортодонтско лечение (7-11 г.)
            </h2>
            <p className="mt-4 text-gray-600">
              Ранно ортодонтско лечение - ФАЗА 1 на ортодонтското лечение се
              провежда по време на 1-вия пик на растеж на детето (между 7 и
              10-11г). Това са лечения, които повлияват скелетния растеж на
              детето преди пробива на всички постоянни зъби. Целта на ранното
              ортодонтско лечение е корекция на тежки зъбни и челюстни
              дисхармонии, които биха се влошили, ако останат нелекувани. Тук
              целта е да спрем влошаването на проблема, да подобрим текущото
              състояние на пациента.{" "}
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-start text-start">
            <h2 className="text-xl font-bold text-heading">
              Фаза 2: Пълно ортодонтско лечение (11-13 г.)
            </h2>
            <p className="mt-4 text-gray-600">
              Поради липсата контрол върху 16-те поникващи постоянни зъби и в
              случай, че поникнат неправилно, ще се наложи всички корекции да
              бъдат направени във Фаза II или т.нар пълно ортодонтско лечение с
              брекети, след пробива на всички постоянни зъби (между 11-13 г).
              Лекувайки децата във ФАЗА 1, подобрявайки тяхното състояние,
              последващата ФАЗА 2 (ако е необходима), би била много по -лека,
              кратка и със стремеж да се предотвратят екстракции (вадене на
              зъби) в постоянното съзъбие. Фокусът тук е ортопедична, лечебна
              част, в която при тесни челюсти създаваме място за пробив на
              постоянните зъби в зъбните редици, лекуваме скелетни
              несъответствия в челюстите и лицето на детето- например силно
              изостанала в развитието си долна челюст и брадичка, обратна
              захапка, отворена захапка, странична кръстосана захапка и др.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
